export const STATUSES = [
  { id: "available", label: "Available" },
  { id: "reserved", label: "Reserved" },
  { id: "sold", label: "Sold" },
];

export const STATUS_LABEL = Object.fromEntries(STATUSES.map((s) => [s.id, s.label]));

export const TYPES = [
  { id: "original", label: "Original" },
  { id: "limited-edition", label: "Limited edition" },
  { id: "sculpture", label: "Sculpture" },
  { id: "other", label: "Other" },
];

export const TYPE_LABEL = Object.fromEntries(TYPES.map((t) => [t.id, t.label]));

export const PRESENTATIONS = [
  { id: "shadow", label: "Shadow", hint: "Unframed canvas or board: lifted off the page with a soft shadow" },
  { id: "none", label: "As photographed", hint: "Already framed, or a cutout/scan on white: shown with no shadow" },
];

export const REQUEST_STATUSES = [
  { id: "new", label: "New" },
  { id: "contacted", label: "Contacted" },
  { id: "completed", label: "Completed" },
  { id: "cancelled", label: "Cancelled" },
];

export const REQUEST_KIND_LABEL = { purchase: "Purchase request", enquiry: "Enquiry", viewing: "Viewing request" };

const trimNumber = (value) => Number(value.toFixed(1)).toString();

export const hasSize = (artwork) => Boolean(artwork.widthCm && artwork.heightCm);

export const formatSize = (artwork) =>
  hasSize(artwork) ? `${trimNumber(artwork.widthCm)} × ${trimNumber(artwork.heightCm)} cm` : "";

export const formatMoney = (value, currency = "GBP") => {
  if (value === null || value === undefined || value === "") return "";
  try {
    return new Intl.NumberFormat("en-GB", { style: "currency", currency, maximumFractionDigits: 0 }).format(value);
  } catch (error) {
    return `${value}`;
  }
};

export const formatPrice = (artwork) => {
  if (artwork.priceOnRequest) return "Price on request";
  if (artwork.salePrice !== null && artwork.salePrice !== undefined) return `${formatMoney(artwork.salePrice, artwork.currency)} (sale)`;
  return formatMoney(artwork.price, artwork.currency || "GBP");
};

export const cropAspect = (artwork) =>
  artwork.crop && artwork.crop.height ? artwork.crop.width / artwork.crop.height : 1;

export const formatDate = (value) =>
  value
    ? new Date(value).toLocaleString("en-GB", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" })
    : "";

// public website, used for "view on site" links
export const SITE_URL =
  process.env.REACT_APP_CLK_SITE_URL || (window.location.hostname === "localhost" ? "http://localhost:3200" : "https://clkart.co.uk");
